export default __webpack_public_path__ + "static/media/TitilliumWeb-Black.b06b28a5.ttf";